import { storeCreator } from '@/utils/store/store.utils';

export interface State {
  activeSection?: string;
  activeModule?: string;
  scrollToModule?: string;
  hideHeader?: boolean;
  handleReset: () => void;
  setActiveSection: (value?: string) => void;
  setScrollToModule: (value?: string) => void;
  setActiveModule: (value?: string) => void;
  setHideHeader: (value?: boolean) => void;
}

export const useStore = storeCreator<State>((set) => ({
  activeSection: undefined,
  activeModule: undefined,
  scrollToModule: undefined,
  hideHeader: false,
  handleReset: () => set(() => ({
    activeSection: undefined,
    activeModule: undefined,
    scrollToModule: undefined,
    hideHeader: false,
  })),
  setActiveSection: (value?: string) => set(() => ({
    activeSection: value,
  })),
  setActiveModule: (value?: string) => set(() => ({
    activeModule: value,
  })),
  setScrollToModule: (value?: string) => set(() => ({
    scrollToModule: value,
  })),
  setHideHeader: (value?: boolean) => set(() => ({
    hideHeader: value,
  })),
}));

export default useStore;
